import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { Grid } from '@mui/material';
import { WButton } from '@wareclouds/wareclouds-ui';
import { ControlledDatePicker } from '../../../common';

import {
  routeHistoryFiltersSchema,
  defaultRouteHistoryFilters,
} from './schemas';
import { useYupValidationTranslations } from '../../../common';
import dayjs from 'dayjs';

export default function RoutesHistoryFilters({
  onSubmit,
  setFilters,
  defaultFilters,
}) {
  const { t } = useTranslation(['form', 'button']);
  const translateError = useYupValidationTranslations();

  const { handleSubmit, control, reset, watch } = useForm({
    resolver: yupResolver(routeHistoryFiltersSchema),
    defaultValues: defaultFilters,
  });

  const start = watch('start');
  const end = watch('end');

  const onClear = () => {
    reset();
    setFilters(defaultRouteHistoryFilters);
  };

  return (
    <Grid
      container
      component="form"
      onSubmit={handleSubmit(onSubmit)}
      spacing={2}
      justifyContent="space-between"
      marginY={2}
    >
      <Grid
        container
        item
        spacing={2}
        xs={12}
        md={4}
        justifyContent="flex-start"
      >
        <Grid item xs={12} md={6}>
          <ControlledDatePicker
            control={control}
            name="start"
            label={t('routes.history.start_date', { ns: 'form' })}
            translateError={translateError}
            datePickerProps={{
              minDate: dayjs(new Date(2018, 0, 1)),
              maxDate: end ? end : dayjs(),
            }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <ControlledDatePicker
            control={control}
            name="end"
            label={t('routes.history.end_date', { ns: 'form' })}
            translateError={translateError}
            datePickerProps={{
              minDate: start ? start : dayjs(new Date(2018, 0, 1)),
            }}
          />
        </Grid>
      </Grid>

      <Grid
        container
        item
        spacing={2}
        xs={12}
        md={4}
        justifyContent="flex-start"
      >
        <Grid item xs={12} md={6}>
          <WButton
            sx={{ height: 40 }}
            type="button"
            variant="outlined"
            color="primary"
            label={t('clear', { ns: 'button' })}
            onClick={onClear}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <WButton
            sx={{ height: 40 }}
            type="submit"
            variant="contained"
            color="primary"
            label={t('apply_filters', { ns: 'button' })}
            fullWidth
          />
        </Grid>
      </Grid>
    </Grid>
  );
}
